// extracted by mini-css-extract-plugin
export default {"labelText":"TextGrid_labelText__eul1O","textGrid":"TextGrid_textGrid__McziU"};